// 調整班表 的員工清單
import * as types from '../actionType';

let initState = [{
  cellPhone: "",
  createAt: "",
  id: 0,
  idNumber: "",
  jobType: "",
  jobTypeId: 0,
  pay: 0,
  qrCode: "",
  realName: "",
  status: 1,
}]

function allStaffListInAdjustState(state = initState, action) {
  switch (action.type) {
      case types.GET_ALL_STAFF_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}

export default allStaffListInAdjustState;